var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousinganywhere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8832A",
    d: "M250,25 L372.5,147.5 L372.5,302.5 L106.25,302.5 L106.25,268.75 L338.75,268.75 L338.75,161.4 L250,72.65 L161.25,161.4 L161.25,235 L127.5,235 L127.5,147.5 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2D2926"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,347 L78,347 L78,369 L98,369 L98,347 L114,347 L114,403 L98,403 L98,382 L78,382 L78,403 L62,403 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,346 C165.5,346 177,358.5 177,375 C177,391.5 165.5,404 149,404 C132.5,404 121,391.5 121,375 C121,358.5 132.5,346 149,346 Z M149,360 C140.5,360 136,366.5 136,375 C136,383.5 140.5,390 149,390 C157.5,390 162,383.5 162,375 C162,366.5 157.5,360 149,360 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,347 L201,347 L201,385 C201,390 204.5,391.5 210,391.5 C215.5,391.5 219,390 219,385 L219,347 L235,347 L235,386 C235,397.5 224.5,404 210,404 C195.5,404 185,397.5 185,386 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,391 L257,389 C258.5,393 262,393.5 267,393.5 C272,393.5 275.5,391.5 275.5,388 C275.5,385 272,383 263.5,381 C250,378 245,372.5 245,363.5 C245,352.5 255,346 267,346 C279,346 288,353 289,363 L274.5,364.5 C273.5,359.5 270.5,358.5 266.5,358.5 C262,358.5 259.5,360 259.5,363 C259.5,365.5 262,367 269,368.5 C284,372 290.5,376.5 290.5,387 C290.5,398 280,404 267,404 C252.5,404 244,397 243,391 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,347 L316,347 L316,403 L300,403 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,347 L341,347 L357.5,382 L357.5,347 L372.5,347 L372.5,403 L357,403 L340,367.5 L340,403 L325,403 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,371.5 L437.5,371.5 L437.5,398.5 C430.5,402.5 421,404 412,404 C393,404 382,391.5 382,375 C382,358.5 394,346 413,346 C425,346 433.5,351.5 437,361.5 L422,365.5 C420,360.5 416.5,359 412.5,359 C404,359 398,365 398,375 C398,385 403.5,391 412.5,391 C416,391 419,390 422,388.5 L422,383 L417.5,383 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#2D2926"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,468 L131,424 L145,424 L161,468 L147.5,468 L143.5,456.5 L132.5,456.5 L128.5,468 Z M135.5,446 L140.5,446 L138,437.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,424 L182,424 L197,456 L197,424 L208,424 L208,468 L198,468 L182,434.5 L182,468 L171,468 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,424 L229.5,424 L237,442 L244.5,424 L257,424 L243,450.5 L243,468 L231,468 L231,450.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,424 L271,424 L278,454 L285.5,424 L295.5,424 L303,454 L310,424 L321,424 L310,468 L298,468 L290.5,437.5 L283,468 L271,468 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,424 L340,424 L340,440.5 L353,440.5 L353,424 L364,424 L364,468 L353,468 L353,450.5 L340,450.5 L340,468 L329,468 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,424 L397,424 L397,434 L384,434 L384,441 L395,441 L395,450.5 L384,450.5 L384,458 L398,458 L398,468 L373,468 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,424 L422.5,424 C430.5,424 436,428 436,435.5 C436,441.5 432,445 426,446.5 L437,468 L424.5,468 L415,447 L417,447 L417,434 L422,434 C424.5,434 426,433 426,431 C426,429 424.5,428 422,428 L417,428 L417,468 L406,468 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,424 L467,424 L467,434 L454,434 L454,441 L465,441 L465,450.5 L454,450.5 L454,458 L468,458 L468,468 L443,468 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousinganywhere);
export default __webpack_public_path__ + "static/media/housinganywhere.547b6eac3dc6c27ba3255e100dcb2d44.svg";
export { ForwardRef as ReactComponent };